import { Experiment } from "@themuse/experiment-client";

const onSite = {
    control_A: "Apply on company site",
    apply_now: "Apply now",
    start_application: "Start application",
    continue: "Continue",
    apply_directly_to_company: "Apply directly to company"
};

const direct = {
    control_B: "Quick Apply",
    easy_apply: "Easy Apply",
    quick_apply_sparkle: "Quick Apply✨",
    apply_directly: "Apply Directly",
    fast_apply: "Fast Apply"
};

export const getApplyButtonText = (
    state: string,
    directApplyService: string,
    experiments: Experiment[],
    getActiveVariant: (arg0: string, arg1: any) => string
): string => {
    const experimentId = directApplyService ? "DIRECT_APPLY_CTA_COPY" : "APPLY_CTA_COPY";
    const enabledVariant: string = getActiveVariant(experimentId, experiments) ?? "";
    const applyBtnText = directApplyService ? direct?.[enabledVariant] : onSite?.[enabledVariant] ?? "";
    const applyTextFallBack = directApplyService ? "Quick Apply" : "Apply on company site";
    const buttonText = state === "live" ? applyBtnText || applyTextFallBack : "Search all jobs";
    return buttonText;
};

export const applyButtonTextConfig: Experiment[] = [
    {
        name: "APPLY_CTA_COPY",
        variants: Object.keys(onSite).map(x => ({
            name: x,
            weight: 20
        }))
    },
    {
        name: "DIRECT_APPLY_CTA_COPY",
        variants: Object.keys(direct).map(x => ({
            name: x,
            weight: 20
        }))
    }
];
